import { render, staticRenderFns } from "./m-delivery.vue?vue&type=template&id=7f272c92&scoped=true"
import script from "./m-delivery.vue?vue&type=script&lang=js"
export * from "./m-delivery.vue?vue&type=script&lang=js"
import style0 from "./m-delivery.vue?vue&type=style&index=0&id=7f272c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f272c92",
  null
  
)

export default component.exports